module.exports = __webpack_public_path__ + "static/img/1.3b87bdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/TheMolding/1.jpg
// module id = Gdhn
// module chunks = 1